<template>
  <statistics-mobile v-if="useMobileStatistics" />
  <statistics-desktop v-else-if="useDesktopStatistics" />
  <div v-else-if="kind">
    <div v-if="useLegacyDesktop" class="d-flex justify-end px-4 pt-3">
      <v-btn text small color="primary" @click="useNewView">{{ $t("report_desktop.new_view") }}</v-btn>
    </div>
    <restaurant-statistics v-if="kind === 'restaurant'" />
    <company-statistics v-else />
  </div>
  <div v-else class="pa-6 text-center">
    <v-icon size="64" color="grey lighten-1">mdi-chart-areaspline</v-icon>
    <div class="text-h6 grey--text mt-4">{{ $t("routes.statistics") }}</div>
    <div class="text-body-2 grey--text text--lighten-1 mt-2">
      {{ $t("statistics_not_available") }}
    </div>
  </div>
</template>

<script>
import RestaurantStatistics from "./RestaurantStatistics.vue";
import CompanyStatistics from "./CompanyStatistics.vue";
import StatisticsDesktop from "@/components/statistics-report/StatisticsDesktop.vue";
import StatisticsMobile from "@/components/statistics-report/mobile/StatisticsMobile.vue";
import { statsKind } from "@/components/statistics-report/statsViews";
import { LEGACY_UI_VALUE } from "@/components/report/desktop/reportQuery";

export default {
  name: "StatisticsPage",
  components: {
    RestaurantStatistics,
    CompanyStatistics,
    StatisticsDesktop,
    StatisticsMobile,
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    /** "restaurant" (admin, restoran, izveštaji), "company-…" (firma) ili null (nalog bez statistike). */
    kind() {
      return statsKind(this.user?.type, this.$store.state.company);
    },
    /** ?ui=stari vraća staru stranicu (tabovi) dok se novi izgled ne potvrdi. */
    useLegacyDesktop() {
      return !this.device.isMobile && this.$route.query.ui === LEGACY_UI_VALUE;
    },
    /** Telefon (širina do 600 px): početna sa izborom grafikona i grafikon u kartici. */
    useMobileStatistics() {
      return Boolean(this.kind) && this.device.isMobile && this.$route.query.ui !== LEGACY_UI_VALUE;
    },
    /** Računar i tablet (širina iznad 600 px): gornja navigacija i traka sa periodom. */
    useDesktopStatistics() {
      return Boolean(this.kind) && !this.device.isMobile && !this.useLegacyDesktop;
    },
  },
  methods: {
    /** Vraća novi izgled (briše ?ui=stari). */
    useNewView() {
      const query = { ...this.$route.query };
      delete query.ui;
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
